import { useSelector } from 'react-redux';
// @ts-ignore
import { FetchPolicy } from 'react-relay/lib/relay-experimental/QueryResource';

import { isArray, map, sum } from 'lodash';
import { createSelector } from 'reselect';

import { FetchKeysStoreKey } from '../reducers/createFetchKeysReducer';
import selectState from '../selectors/selectState';

const makeSelectFetchKey = (key: FetchKeysStoreKey | FetchKeysStoreKey[]) =>
  createSelector(
    selectState,
    (state) => {
      if (isArray(key)) {
        return sum(map(key, (k) => state.fetchKeys[k]));
      }
      return state.fetchKeys[key];
    },
  );

export default function useQueryOptions(
  key: FetchKeysStoreKey | FetchKeysStoreKey[],
): {
  fetchKey: number;
  fetchPolicy: FetchPolicy;
} {
  const fetchKey = useSelector(makeSelectFetchKey(key));

  return {
    fetchPolicy: 'network-only',
    fetchKey,
  };
}
